// extracted by mini-css-extract-plugin
export var lbContainerOuter = "y_t7";
export var lbContainerInner = "y_t8";
export var movingForwards = "y_t9";
export var movingForwardsOther = "y_vb";
export var movingBackwards = "y_vc";
export var movingBackwardsOther = "y_vd";
export var lbImage = "y_vf";
export var lbOtherImage = "y_vg";
export var prevButton = "y_vh";
export var nextButton = "y_vj";
export var closing = "y_vk";
export var appear = "y_vl";